<template>
  <div class="history-price" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="form" ref="form" label-width="70px">
      <el-form-item label="状态" prop="state">
        <el-select v-model="form.state" placeholder="请选择状态" clearable>
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型" prop="orderType">
        <el-select v-model="form.orderType" placeholder="请选择业务类型" clearable>
          <el-option
            v-for="item in orderTypeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="customName">
        <el-input v-model="form.customName"></el-input>
      </el-form-item>
      <el-form-item label="上传信息" prop="formData">
        <el-input v-model="form.formData"></el-input>
      </el-form-item>
       <el-form-item label="创建时间" prop="createTime">
         <el-date-picker
          popper-class="picktime-box"
          v-model="form.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          :clearable="false">
        </el-date-picker>
      </el-form-item>
       <el-form-item label="更新时间" prop="updateTime">
         <el-date-picker
          popper-class="picktime-box"
          v-model="form.updateTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="id"
        label="编码"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderTypeDesc"
        label="业务类型"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="customName"
        label="客户名称"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="formData"
        label="上传信息"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="url"
        label="url"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="140"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        width="140"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="result"
        label="返回信息"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state === '失败'"
            v-permission="'0011401'"
            size="mini"
            @click="handleSync(scope.row)">手工同步</el-button>
          <el-button
            v-if="scope.row.state === '失败'"
            v-permission="'0011402'"
            size="mini"
            @click="handleChange(scope.row)">修改入参</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="list.length > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-dialog title="修改上传信息" @close="handleClose" width="800px" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="上传信息" label-width="70px">
          <el-input v-model="dataJson" placeholder type="textarea" autosize></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { formatTime } from '../../../common/utils'

export default {
  name: 'tripartiteLog',
  data () {
    return {
      form: {
        createTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)],
        updateTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)],
        customName: '',
        state: '',
        formData: '',
        orderType: ''
      },
      dataJson: '',
      dataJsonId: '',
      // jsonData: '',
      checkDialogShow: false,
      dialogFormVisible: false,
      checkData: {},
      statusArr: [
        { value: '', label: '全部' },
        { value: '成功', label: '成功' },
        { value: '失败', label: '失败' }
      ],
      orderTypeArr: [
        { value: '1', label: '销售' },
        { value: '2', label: '调拨' }
      ]
    }
  },
  computed: {
    ...mapState({
      list: state => state.allotAutomaticLog.list,
      listState: state => state.allotAutomaticLog.listState
    })
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getAllotAutomaticLog', 'syncInfo', 'getError', 'changeUploadInfo', 'changeAutoUploadInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getAllotAutomaticLog(params)
    },
    handleClose () {
      this.dialogFormVisible = false
    },
    checkJsonData () {
      try {
        var isSu = JSON.stringify(JSON.parse(this.dataJson), null, 4)
        return isSu
      } catch (e) {
        return false
      }
    },
    reset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getAllotAutomaticLog({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getAllotAutomaticLog({ pageNo: val })
    },
    // 修改上传信息
    handleChange (row) {
      // this.jsonData = row.notEncryptContent
      // console.log(this.$refs.preTag.innerHTML)
      // const preJson = document.getElementById('jsonData').innerHTML
      this.dataJsonId = row.id
      this.dataJson = row.formData
      this.dialogFormVisible = true
    },
    handleSubmit () {
      var json = this.checkJsonData()
      console.log('json')
      console.log(json)
      if (!json) {
        this.$message.error('JSON数据格式校验失败，请检查后重新提交')
      } else {
        const params = {
          failDataId: this.dataJsonId,
          failData: this.dataJson
        }
        this.changeAutoUploadInfo(params).then(() => {
          this.handleSearch()
          this.dialogFormVisible = false
        })
      }
    },
    // 手工同步
    handleSync (row) {
      const params = {
        failDataId: row.id,
        failData: row.formData,
        system: 37
      }
      this.syncInfo(params).then(res => {
        if (!res) {
          this.$message({
            message: '同步失败',
            type: 'error'
          })
        }
        this.handleSearch()
      })
    }
  }
}
</script>
<style lang="scss">
.el-tooltip__popper{
  max-height: 200px;
  overflow: hidden;
}
</style>
